import React from 'react';

export default class ShowOrHidePassText extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showPwdTextFlag: false,
    };
  }

  showHidePwdText = () => {
    let pwdInputField = document.getElementById(this.props.elementId);
    if (pwdInputField.type === 'password') {
      pwdInputField.type = 'text';
      this.setState({
        showPwdTextFlag: true,
      });
    } else {
      pwdInputField.type = 'password';
      this.setState({
        showPwdTextFlag: false,
      });
    }
  };

  render() {
    return (
      <div className="icon-wrapper" onClick={() => this.showHidePwdText()}>
        {this.state.showPwdTextFlag ? (
          <div className="show-pwd-icon" id="show-pwd-text-hide">
            Hide
          </div>
        ) : (
          <div className="show-pwd-icon">Show</div>
        )}
      </div>
    );
  }
}

export const PasswordHint = (props) => {
  let animationStateForPassWordHints = props.showPasswordHint ? ' slide-down-from-top' : ' slide-down-to-top';
  return (
    <div className={'inline-flex noscroll' + animationStateForPassWordHints}>
      <ul className="color-placeholder text-size-mms mrtnull mrbs mrrm" style={{ paddingLeft: '20px' }}>
        <li>{APP.LANGUAGE.PasswordHints.MinChars}</li>
        <li>{APP.LANGUAGE.PasswordHints.SpcChar}</li>
      </ul>
      <ul className="color-placeholder text-size-mms mrtnull mrbs" style={{ paddingLeft: '20px' }}>
        <li>{APP.LANGUAGE.PasswordHints.Letter}</li>
        <li>{APP.LANGUAGE.PasswordHints.Number}</li>
      </ul>
    </div>
  );
};
